module.exports = __webpack_public_path__ + "static/img/003.438b4c4a.jpg";